/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subscription} from "rxjs";
import {ScheduleItem} from "../../models/schedule/ScheduleItem";
import {CompEvent} from "../../models/CompEvent";
import {EntryScheduleItem} from "../../models/schedule/EntryScheduleItem";
import {ScheduleService} from "../../providers/schedule-service";
import {reorderArray} from "ionic-angular";

/**
 * Generated class for the EventSchedule component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'event-schedule',
  templateUrl: 'event-schedule.html'
})
export class EventSchedule implements OnInit, OnDestroy {

  entries: Array<ScheduleItem> = new Array();

  private _entrySubscription: Subscription;

  @Input()
  date: string;

  @Input()
  event: CompEvent;

  @Output()
  entrySelected: EventEmitter<EntryScheduleItem> = new EventEmitter();

  constructor(private scheduleService: ScheduleService, private ref: ChangeDetectorRef) {
    console.log('Hello DaySchedule Component');
  }

  selectEntry(entry: EntryScheduleItem) {
    this.entrySelected.emit(entry);
  }

  scheduleHeader(record: ScheduleItem, recordIndex: number, records: ScheduleItem[]) {
    if (recordIndex == 0) {
      return record.date;
    }

    let numRecords: number = records.length;

    if (recordIndex == numRecords) {
      return null;
    }

    if (record.date != records[recordIndex - 1].date) {
      return record.date;
    }

    return null;

  }

  trackId(index, item: ScheduleItem) {
    return item.id;
  }

  reorderItems(indexes) {
    this.entries = reorderArray(this.entries, indexes);
  }

  ngOnInit(): void {
    // this.entries = this.scheduleService._entries;
    this._entrySubscription = this.scheduleService.entries.subscribe(entries => {
      this.entries = entries;
      console.log(this.entries);
      this.ref.detectChanges();
    }, err => {
      console.error(err);
    });
  }

  ngOnDestroy(): void {
    if (this._entrySubscription) {
      this._entrySubscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/event-schedule/event-schedule.ts